import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useDeviceFeatures } from '@/hooks/useResponsive';

interface ActivityBackButtonProps {
  isExpanded?: boolean;
  onCloseExpanded?: () => void;
}

const ActivityBackButton: React.FC<ActivityBackButtonProps> = ({
  isExpanded = false,
  onCloseExpanded,
}) => {
  const navigate = useNavigate();
  const { isMobile } = useDeviceFeatures();

  return (
    <motion.button
      onClick={() => {
        if (isExpanded && onCloseExpanded) {
          onCloseExpanded();
        } else {
          navigate('/');
        }
      }}
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.3 }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      style={{
        position: 'fixed',
        top: '100px',
        left: isMobile ? '15px' : '20px',
        zIndex: 9999,
        backgroundColor: '#1C3F75',
        color: '#FFFFFF',
        border: 'none',
        borderRadius: '50%',
        width: isMobile ? '44px' : '48px',
        height: isMobile ? '44px' : '48px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
        transition: 'all 0.3s ease',
      }}
      aria-label="Go back to home"
    >
      <svg
        width={isMobile ? '20' : '24'}
        height={isMobile ? '20' : '24'}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        strokeWidth={2.5}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
      </svg>
    </motion.button>
  );
};

export default ActivityBackButton;
